export default {
  partner:
    'Set your Stripe processing fee or confirm a 0% margin. Until then your restaurants on Stripe can’t go live.',
  partner_live_one:
    'Set your Stripe processing fee or confirm a 0% margin. Until then your restaurants on Stripe can’t go live, and your live restaurant takes no online payments.',
  partner_live_other:
    'Set your Stripe processing fee or confirm a 0% margin. Until then your restaurants on Stripe can’t go live, and your {{count}} live restaurants take no online payments.',
  restaurant: 'Online payments are paused until your partner sets its processing fee. Cash payments still work.',
  cta: 'Set processing fee',
};
